/* eslint-disable */
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import React from 'react';
import { compose } from 'redux';
import {
  USER_SERVICE_PRESENCE_STATUS_AWAY,
  USER_SERVICE_PRESENCE_STATUS_OFFLINE,
  USER_SERVICE_PRESENCE_STATUS_PRESENT,
  USER_SERVICE_PRESENCE_STATUS_UNKNOWN,
} from '../../Constants/User/User.constants';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ProfilePicPropTypes from './ProfilePic.component.props';
import profilePicStyles from './ProfilePic.component.styles';

/**
 * ProfilePicComponent
 * @export
 * @class ProfilePicComponent
 * @extends {React.Component<ProfilePicComponentComposedProps, ProfilePicComponentState>}
 */
export class ProfilePicComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ProfilePicComponentProps>}
   * @memberof ProfilePicComponent
   */
  static defaultProps = {
    hidePresence: false,
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ProfilePic`}
   * @memberof ProfilePicComponent
   */
  static displayName = `ProfilePic`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ProfilePicComponent
   */
  static propTypes = ProfilePicPropTypes;

  /**
   * Data specific to the `<ProfilePicComponent />` instance
   * @type {ProfilePicComponentState}
   * @memberof ProfilePicComponent
   */
  state = {};

  /**
   * Generate a semi-random number to use as the `index` representing which color should be the background of an Avatar
   * @param {string} str The string to generate the `index` from
   * @returns {number} The color to use
   * @memberof ProfilePicComponent
   */
  getColorIndex = (str) => {
    const { classes } = this.props;
    const total = String(str)
      .split(``)
      .reduce((prev, next) => prev + next.charCodeAt(0), 0);
    const numberOfColors = Object.keys(classes).filter((name) => /avatarFallbackColor\d/.test(name)).length;
    const index = (total % numberOfColors) + 1;
    return index;
  };

  /**
   * Render the component
   * @param {React.Component} avatar The rendered `<ProfilePicComponent />`
   * @returns {React.Component} The rendered `<ProfilePicComponent />`
   * @memberof ProfilePicComponent
   */
  renderAvatar = (avatar) => {
    const { classes, hidePresence, user } = this.props;
    if (hidePresence) {
      return avatar;
    }
    return (
      <div className={cn(classes.root)}>
        {avatar}
        <div
          className={cn(classes.presence, {
            [classes.presenceAway]: user.presence === USER_SERVICE_PRESENCE_STATUS_AWAY,
            [classes.presenceOffline]: user.presence === USER_SERVICE_PRESENCE_STATUS_OFFLINE,
            [classes.presencePresent]: user.presence === USER_SERVICE_PRESENCE_STATUS_PRESENT,
            [classes.presenceUnknown]: user.presence === USER_SERVICE_PRESENCE_STATUS_UNKNOWN,
          })}
        />
      </div>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ProfilePicComponent />`
   * @memberof ProfilePicComponent
   */
  render() {
    const { classes, user } = this.props;
    if (!user.avatarUrl) {
      if (!user.login || !user.initials) {
        return null;
      }
      const index = this.getColorIndex(user.login);
      return this.renderAvatar(<Avatar className={cn(classes[`avatarFallbackColor${index}`])}>{user.initials}</Avatar>);
    }
    return this.renderAvatar(
      <Avatar>
        <img alt={`${user.displayName} <${user.login}>`} src={user.avatarUrl} />
      </Avatar>,
    );
  }
}

/** @type {React.ComponentClass<ProfilePicComponentProps>} */
const ProfilePic = compose(withStyles(themeCreateInjectableStyles(profilePicStyles), { withTheme: true }))(ProfilePicComponent);

export default ProfilePic;
